import { BASE_PATH } from '@/constants/config';
import { EXTERNAL_PROJECT_HEADER } from '@/utils/session/external-session-header';

/**
 * Global configuration for the core-api client.
 * Import this module early (e.g., in __root.tsx) to ensure the client
 * is configured before any API calls are made.
 *
 * This sets the baseURL to include the /next prefix for client-side requests,
 * ensuring requests go to /next/v4/... instead of /v4/...
 * On QA/production, /v4/* routes to the OLD app, while /next/* routes to THIS app.
 */
import { client } from '../api/core-api/client.gen';

/** `/participants/external/projects/<projectId>/...`, the external study pages. */
const EXTERNAL_PAGE = new RegExp(
  `^${BASE_PATH}/participants/external/projects/([\\da-f]{24})(?:/|$)`,
  'i',
);

if (globalThis.window !== undefined) {
  client.setConfig({
    baseURL: `${globalThis.location.origin}${BASE_PATH}`,
  });

  // An external participant's study pages call the same endpoints as the
  // participant app, but as their project's external session. The proxy picks
  // that session from this header; without it, it uses the participant app's.
  client.instance.interceptors.request.use((config) => {
    const projectId = EXTERNAL_PAGE.exec(globalThis.location.pathname)?.[1];
    if (projectId) {
      config.headers.set(EXTERNAL_PROJECT_HEADER, projectId);
    }
    return config;
  });
}
